import api from './client';

const addSubscriber = async (subscriber) => {
  const res = await api.post('/waitlist', subscriber)
  return res.data;
};

const waitlist = { addSubscriber }
export default waitlist;
